// @ts-nocheck
import {
    chain,
    PopulateApiParameter,
    UpdateCart,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import setNotes from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetNotes";
import { addToChainAfter, createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

replaceInChain(chain, PopulateApiParameter, props => {
    if (!props.cartToUpdate) {
        return;
    }

    const {
        pages: {
            checkoutReviewAndSubmit: { requestedDeliveryDate, requestedPickupDate },
        },
    } = props.getState();
    const tempDeliveryDate =
        typeof requestedDeliveryDate !== "undefined"
            ? requestedDeliveryDate
            : props.cartToUpdate.requestedDeliveryDateDisplay;
    const tempPickupDate =
        typeof requestedPickupDate !== "undefined"
            ? requestedPickupDate
            : props.cartToUpdate.requestedPickupDateDisplay;

    props.apiParameter = {
        cart: {
            ...props.cartToUpdate,
            requestedDeliveryDate: props.cartToUpdate.requestedDeliveryDate, // Greif
            requestedPickupDate: props.cartToUpdate.requestedPickupDate, // Greif,
        },
    };
});

export const AfterUpdateCart = createChainHandler("AfterUpdateCart", chain, props => {
    props.dispatch(setNotes({ notes: "" }));
});

addToChainAfter(chain, UpdateCart, AfterUpdateCart);
